var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.49 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #6533e9;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.79,58.75H8.47v-18.12C3.73,36.43.75,30.38.75,23.66.75,11,11.27.75,24.24.75s23.47,10.25,23.47,22.91c0,.87-.05,1.74-.15,2.6-.05.43.03.86.24,1.23l4.71,8.26c.57.98,0,2.21-1.1,2.45l-4.84,1v7.84c0,1.35-1.1,2.45-2.47,2.45h-10.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.52,45.09l1.68,1.67c1.74,1.74,4.11,2.72,6.58,2.72"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.8 49.48 35.8 58.75 32.64 58.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.08,16.43s-1.43.43-1.43,2.32,1.61,2.8,2.72,3.96c1.11,1.16,3.18,6.52,7.42,6.52s5.85-3.53,5.85-7.15-3.46-5.7-4.93-4.88-.14,3.14,1.34,3.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.46,
    y1: 17.37,
    x2: 27.46,
    y2: 17.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.6,13.15c1.99-.05,5.13.99,5.13,5.06,0,5.32-3.69,8.07-6.63,8.07-.98,0-2.67,0-3.99-.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.2,15.46s1.3-3.41-.4-5.77c-3.03-4.19-9.83-4.5-10.94-.56-.74,2.61,5.62,3.33,8.11,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.91,11.93s.88.92.56,2.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.9,10.09s.35-.79,1.19-1.75c1.17-1.35,3.31-3.03,6.8-3.35,2.12-.18,4.22.59,5.6,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.35,15.46c-.47,1.11-1.57,1.74-2.54,1.25-.97-.48-1.5-3.45,1.34-6.45,2.54-2.68,5.11-2.21,5.94-1.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.14,15.66c-1.44.97-2.58,3.06-2.73,4.97-.33,4.18,1.57,6.66,4.8,6.71,3.22.05,6.17-3.42,8.71,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.51,29.22s.83,2.57-3.96,2.47c-4.79-.1-6.59,5.75-6.59,5.75h-3.27s1.89-3.29,1.43-5.27c-.46-1.98-1.75-.92-4.24-1.64-2.49-.72-1.72-3.67-1.72-3.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.02,19.29s1.15-1.68,2.31.05c1.17,1.73,1.56,5.7,3.28,5.98,1.72.28,1.83-.78,1.8-1.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.8,16.75s-1.22.35-.83,2.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.01,19.12s-2.25-1.11-3.01.25c-.61,1.09,1.6,3.7-2.3,4.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.38,19.92s.9,1.78,2.62.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.64,12.06s-2.78-1.47-4.71,0c-1.93,1.47-3.42,1.93-5.28,1.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.76,8.75s.7.99-.17,2.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.7,23.05s2.15-2.67,5.67-.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.02,19.71s-1.66,1.34-2.83,0-1.6-2.44-3.62-1.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.2,19.71s.77,2.33-.74,2.68"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonality);
export default __webpack_public_path__ + "static/media/personality.c3a60d37d0d57cba685b95f512885cbe.svg";
export { ForwardRef as ReactComponent };